import React, {Component} from "react";
import ReportingToolTip from "./reporting-tool-tip";

class SingleReportingTooltip extends Component {
  render() {
    return <ReportingToolTip {...this.props} />;
  }
}
export default SingleReportingTooltip;
